import { Button } from '@/components/catalyst-ui/button'
import { Input, InputGroup } from '@/components/catalyst-ui/input'
import { Text } from '@/components/catalyst-ui/text'
import { Heading } from '../../../components/catalyst-ui/heading'
import { MagnifyingGlassIcon } from '@/assets/icons'
export default function DomainSearchSection({ 
  domainInput, 
  onDomainInputChange, 
  onDomainSearch,
  searchedDomain = null,
  showOwnershipMessage = false 
}) {
  return (
    <>
      {/* Domain Connection Section */}
      <div className="max-w-[432px] max-h-[220px] mx-auto text-left flex flex-col justify-between">
        <div>
          <Heading level={2}>Buy or Add New Domain</Heading>
          <Text className="mt-2 !text-sm font-normal text-[#71717B]">
            Enter the web address you want for your site. It can be domain you want to buy or one you already bought.
          </Text>
        </div>
        <div className="flex flex-col sm:flex-col gap-5 py-3 ">
          <div>
            <InputGroup>
              <MagnifyingGlassIcon data-slot="icon" />
              <Input
                type="text"
                placeholder="Type the domain you want"
                value={domainInput}
                onChange={(e) => onDomainInputChange(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && onDomainSearch()}
              />
            </InputGroup>
          </div>
          <div className='flex justify-center'>
            <Button
              onClick={onDomainSearch}
              color="dark"
              className="text-white"
            >
              Search Domain
            </Button>
          </div>
        </div>
      </div>
    
    </>
  )
}
